import Vue from "vue";
import VueRouter from "vue-router";

// Layout
import Layout from "@/layout";
import ErrorLayout from "@/layout/error";
import AuthLayout from "@/layout/auth";

Vue.use(VueRouter);

const errors = {
  key: "errors",
  path: "/errors",
  layout: "error",
  name: "Errors",
  redirect: "/errors/404",
  children: [
    {
      path: "403",
      name: "Forbidden",
      component: "403",
    },
    {
      path: "404",
      name: "PageNotFound",
      component: "404",
    },
    {
      path: "500",
      name: "ServerError",
      component: "500",
    },
    {
      path: "502",
      name: "BadGateway",
      component: "502",
    },
  ],
};

const errorRouters = [errors].map((r) => ({
  ...r,
  component: ErrorLayout,
  children: r.children.map((c) => ({
    ...c,
    component: () => import(`@/views/errors/${c.component}`),
  })),
}));

const authRouters = [
  {
    path: "/login",
    component: AuthLayout,
    children: [
      {
        path: "",
        name: "Login",
        component: () => import("@/views/login/index"),
        meta: { auth: false, title: "Đăng nhập" },
      },
    ],
  },
];

const commonRouters = [
  {
    path: "/",
    component: Layout,
    layout: "root",
    children: [
      {
        path: "",
        name: "Dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: {
          auth: true,
          title: "Trang chủ",
          icon: "el-icon-menu",
          bottom: true,
        },
      },
    ],
  },
  {
    path: "/organizations",
    component: Layout,
    layout: "root",
    children: [
      {
        path: "",
        name: "Organizations",
        component: () => import("@/views/organizations/index"),
        meta: {
          auth: true,
          title: "Tổ chức",
          icon: "el-icon-s-management",
          bottom: true,
        },
      },
    ],
  },
  {
    path: "/organizations/:id",
    component: Layout,
    children: [
      {
        path: "",
        name: "OrganizationDetail",
        component: () => import("@/views/organizations/detail"),
        meta: {
          auth: true,
          title: "Chi tiết tổ chức",
        },
      },
    ],
  },
  {
    path: "/roles",
    component: Layout,
    layout: "root",
    children: [
      {
        path: "",
        name: "Roles",
        component: () => import("@/views/roles/index"),
        meta: {
          auth: true,
          title: "Quyền hạn",
          icon: "el-icon-s-order",
          bottom: true,
        },
      },
    ],
  },
  {
    path: "/accounts",
    component: Layout,
    layout: "root",
    children: [
      {
        path: "",
        name: "Accounts",
        component: () => import("@/views/accounts/index"),
        meta: {
          auth: true,
          title: "Tài khoản",
          icon: "el-icon-user",
          bottom: true,
        },
      },
    ],
  },
  {
    path: "/contracts",
    component: Layout,
    layout: "root",
    children: [
      {
        path: "",
        name: "Contracts",
        component: () => import("@/views/contracts/index"),
        meta: {
          auth: true,
          title: "Quy trình",
          icon: "el-icon-finished",
          bottom: true,
        },
      },
    ],
  },
  {
    path: "/contracts/:id",
    component: Layout,
    children: [
      {
        path: "",
        name: "ContractSteps",
        component: () => import("@/views/contracts/detail"),
        meta: {
          auth: true,
          title: "Chi tiết quy trình",
          parent: 'Contracts'
        },
      },
    ],
  },
  {
    path: "/config",
    component: Layout,
    layout: "root",
    children: [
      {
        path: "",
        name: "Config",
        component: () => import("@/views/config/index"),
        meta: {
          auth: true,
          title: "Cấu hình dữ liệu",
          icon: "el-icon-setting",
          bottom: true,
        },
      },
    ],
  },
  {
    path: "/config/:id",
    component: Layout,
    children: [
      {
        path: "",
        name: "ConfigDetail",
        component: () => import("@/views/config/detail"),
        meta: {
          auth: true,
          title: "Cấu hình chi tiết",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    ...authRouters,
    ...commonRouters,
    ...errorRouters,
    { path: "*", redirect: "/errors/404", hidden: true },
  ],
});

export default router;
